<template>
    <div class="row">
        <!-- search input -->
        <div 
            :class="`custom-search col-sm-${sizeSearchSm} col-md-${sizeSearchMd} col-lg-${sizeSearchLg}`" 
            v-if="searchFilter"
        >
            <div class="d-flex align-items-center search-input-wrapper">
                <b-form-input
                    v-model="filterTerm"
                    placeholder="Pesquise aqui"
                    type="text"
                    class="input-search"
                    @input="onFilterInput"
                    @keyup.enter="onSearchClick"
                />
                <button
                    v-if="serverSide"
                    type="button"
                    class="btn-search-filter"
                    @click="onSearchClick"
                >
                    <SearchIcon />
                </button>
            </div>
        </div>
        <div :class="`col-lg-${12 - sizeSearchLg} col-md-${12 - sizeSearchMd} col-sm-${12 - sizeSearchSm}`">
          <slot name="col-right" />
        </div>
        <div class="container-fluid filter-options">
            <slot name="filter"/>
        </div>
        <!-- Table -->
        <div class="table-responsive">
            <b-table
                id="table-orders"
                :sticky-header="stickyHeader"
                :no-border-collapse="noCollapse"
                :items="rowsTable"
                :fields="fields"
                :per-page="tablePerPage"
                :current-page="tableCurrentPage"
                :searchFilter="searchFilter"
                :striped="striped"
                :sort-by="sortBy"
                :sort-desc="sortDesc"   
            >
                <!-- Slot: Table Column -->
                <template #head()="scope">
                    <div class="text-nowrap">
                        {{ $t(scope.label) }}
                    </div>
                </template>
                

                <!-- Slot: Table Row -->

                <template
                    v-for="slot in Object.keys($scopedSlots)"
                    v-slot:[slot]="props"
                >
                    <slot v-bind="props" :name="slot" />
                </template>
            </b-table>
            <div class="not-found" v-if="rowsTable.length == 0">
                <span><SearchIcon /><h3>Nenhum resultado encontrado!</h3></span>
            </div>
        </div>

        <div v-if="showPagination" class="col-12 d-flex justify-content-between col-footer-table">
            <div class="d-flex align-items-center mb-0 mt-1 por-pagina">
                <span class="text-nowrap">
                    Linhas por página
                </span>
                <b-form-select
                    v-model="pageLength"
                    :options="['10', '20', '30']"
                    class="mx-1"
                />
            </div>

            <b-pagination
                aria-controls="table-orders"
                :value="paginationCurrentPage"
                :total-rows="paginationTotalRows"
                :per-page="pageLength"
                class="mt-1 mb-0"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                @input="onPageInput"
            >
                <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
            </b-pagination>
        </div>
    </div>
</template>

<script>
import SearchIcon from '@/assets/images/pages/Search.svg'
import {
    BPagination,
    BTable,
    BFormSelect,
    BDropdownItem,
    BDropdown,
    BFormInput,
    BFormGroup,
} from "bootstrap-vue";

export default {
    components: {
        BPagination,
        BTable,
        BFormSelect,
        BDropdownItem,
        BDropdown,
        BFormInput,
        BFormGroup,
        SearchIcon
    },
    props: {
        rows: {
            type: Array,
            default: null,
        },
        fields: {
            type: Array,
            default: null,
        },
        noCollapse: {
            type: Boolean,
            default: true,
        },
        stickyHeader: {
            type: String,
            default: true,
        },
        searchFilter: {
            type: Boolean,
            default: true,
        },
        striped: {
            type: Boolean,
            default: false,
        },
        sortDesc: {
            type: Boolean,
            default: false,
        },
        sortBy: {
            type: String,
            default: "",
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        sizeSearchSm: {
            type: Number,
            default: '',
        },
        sizeSearchMd: {
            type: Number,
            default: 4,
        },
        sizeSearchLg: {
            type: Number,
            default: '',
        },
        totalRows: {
            type: Number,
            default: null,
        },
        serverSide: {
            type: Boolean,
            default: false,
        },
        showPagination: {
            type: Boolean,
            default: true,
        },
        clientPagination: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filterTerm: "",
            pageLength: 10,
            localCurrentPage: 1,
            searchDebounceTimer: null,
        };
    },
    computed: {
        rowsTable() {
            if (this.serverSide || !this.filterTerm) {
                return this.rows;
            }
            return this.rows.filter((o) =>
                Object.keys(o).some((k) =>
                    String(o[k])
                        .toLowerCase()
                        .includes(this.filterTerm.toLowerCase())
                )
            );
        },
        tablePerPage() {
            return (this.serverSide && !this.clientPagination) ? 0 : this.pageLength;
        },
        tableCurrentPage() {
            return (this.serverSide && !this.clientPagination) ? 1 : this.localCurrentPage;
        },
        paginationCurrentPage() {
            if (this.serverSide && !this.clientPagination) {
                return this.currentPage;
            }
            return this.localCurrentPage;
        },
        paginationTotalRows() {
            if (this.clientPagination || !this.serverSide) {
                return this.rowsTable.length;
            }
            return this.totalRows != null ? this.totalRows : this.rowsTable.length;
        },
    },
    watch: {
        pageLength(val) {
            if (this.serverSide && !this.clientPagination) {
                this.$emit('alteraPerPageListagem', parseInt(val, 10));
            } else {
                this.localCurrentPage = 1;
            }
        },
        rows() {
            if (this.clientPagination) {
                this.localCurrentPage = 1;
            }
        },
    },
    beforeDestroy() {
        clearTimeout(this.searchDebounceTimer);
    },
    methods: {
        onPageInput(page) {
            if (this.serverSide && !this.clientPagination) {
                this.$emit('alteraPaginaListagem', page);
            } else {
                this.localCurrentPage = page;
            }
        },
        onFilterInput() {
            if (!this.serverSide) return;
            clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = setTimeout(() => {
                this.localCurrentPage = 1;
                this.$emit('buscaTextFilter', this.filterTerm);
            }, 5000);
        },
        onSearchClick() {
            if (!this.serverSide) return;
            clearTimeout(this.searchDebounceTimer);
            this.localCurrentPage = 1;
            this.$emit('buscaTextFilter', this.filterTerm);
        },
    },
};
</script>

<style lang="scss">
@media (max-width: 480px) {
    .col-footer-table {
        align-items: center;
        flex-direction: column;
    }
}

.table-responsive{

    &::-webkit-scrollbar {
        height: 5px !important;               /* width of the entire scrollbar */
        border-radius: 50%;
      }
      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #FBEEE8;   
        
      }
      &::-webkit-scrollbar-thumb {
        background-color: #CFC4BE;    /* color of the scroll thumb */
        border-radius: 20px;       /* roundness of the scroll thumb */
        border: 10px solid transparent
      }
}

.b-table-sticky-column,
.table-b-table-default {
    background-color: #ffff !important;
    border: 1px solid #ebe9f1 !important;
    .dark-layout & {
        background-color: #283046 !important;
        color: #d0d2d6 !important;
    }
}
.table {
    thead th {
        text-transform: none;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: #4c4541;
        border-top: 1px solid #ebe9f1;
        background-color: #faf6f2 !important;
        border-bottom: 0;
        .dark-layout & {
            background-color: #283046 !important;
            outline-color: #3b4253 !important;
        }
        &.col-sm-header{
            width: 1%;
        }
        &.operators{
            width: 28%;
        }
    }
    tbody tr {
        td {
            font-family: "Roboto";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #4c4541;
        }

        .custom-switch {
            align-items: center;
            .custom-control-input:checked ~ .custom-control-label::before {
                background-color: #974900 !important;
            }
            .custom-control-input:checked ~ .custom-control-label::after {
                left: -7px !important;
            }
            .custom-control-label::before {
                width: 22px;
                height: 12px;
            }
            .custom-control-label::after {
                top: 1.6px;
                left: 2px;
                width: 8px;
                height: 8px;
            }
        }
    }
    tbody {
        tr:nth-child(2n + 1) {
            background-color: #ffff;
        }
        tr:nth-child(2n) {
            background-color: #fafafa;
        }
    }
}
.b-table-sticky-column.fix-1 {
    padding: 9px 52px !important;
}
.b-table-sticky-column.fix-2 {
    left: 187px !important;
    padding: 9px 20px !important;
}
.b-table-sticky-column.fix-3 {
    left: 301px !important;
    padding: 9px 30px !important;
}
.pagination {
    .page-item.active {
        height: 33px;
        button {
            background-color: #974900;
        }
    }
    .page-item.disabled {
        .page-link {
            background-color: #faf6f2;
            color: #4c4541;
        }
    }
}

.card-body {
    padding: 16px;
    .card-title {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 26px;
        color: #4c4541;
        margin-bottom: 16px !important;
    }
    .search-input-wrapper {
        width: 100%;
        gap: 8px;
    }
    .input-search {
        margin-bottom: 0;
        flex: 1;
    }
    .btn-search-filter {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 12px;
        border: 1px solid #974900;
        border-radius: 5px;
        background-color: #974900;
        cursor: pointer;
        flex-shrink: 0;
        &:hover {
            background-color: #9d5815;
            border-color: #9d5815;
        }
        svg path {
            fill: #fff;
        }
    }
    .col-footer-table {
        .por-pagina {
            span {
                font-family: "Roboto";
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #4c4541;
            }
        }
        .custom-select {
            max-width: 62px;
            padding: 4px 34px 4px 8px;
            background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.17975 3.78813L7.05862 0.855236L7.64775 1.44457L4.00127 5.14393L0.352313 1.44451L0.941458 0.855158L3.823 3.7882L4.00141 3.96981L4.17975 3.78813Z' fill='%23974900' stroke='%23974900' stroke-width='0.5'/%3E%3C/svg%3E") !important;
        }
    }
}
</style>
